import serverConnect from "../services/serverConnect";

const getConfigurationByName = (configurations, name) => {
    if (name) {
        for (var idx = 0; idx < configurations.length; idx++) {
            const c = configurations[idx];
            if (c && c.text && c.text === name) {
                return c;
            }
        }
    }
    return {};
};

const store = {
    namespaced: true,

    state: {
        configurations: [],
        active: undefined
    },
    getters: {
        configuration: (state, name) => {
            return getConfigurationByName(state.configurations, name);
        },

        activeConfiguration: state => {
            return getConfigurationByName(state.configurations, state.active);
        },

        active: state => {
            return state.active;
        }
    },
    mutations: {
        setActive(state, name) {
            state.active = name;
        },
        add(state, config) {
            const confName = config.text;
            state.configurations.push(JSON.parse(JSON.stringify(config)));
            if (state.configurations.length == 1) {
                state.active = confName;
            }
        },
        clear(state) {
            state.active = undefined;
            state.configurations.length = 0;
        }
    },
    actions: {
        initStore(context) {
            serverConnect.on("config", data => {
                context.dispatch("add", data);
            });
            serverConnect.emit("getconfig", {});
        },
        setActive(context, name) {
            context.commit("setActive", name);
        },
        add(context, config) {
            context.commit("add", config);
        },
        clear(context) {
            context.commit("clear");
        }
    }
};

export default store;
